import React from "react";

const ChatHistorySection = ({ title, messages,callbackIds, isActive }) => {

  return (
    
    <div className="flex flex-col gap-[10px]">
      <p className="medium text-blue font-medium">{title}</p>
      <div >
        {messages.slice().reverse().map((message, index) => {
          return(<p
            key={index}
            className="txt-color font-medium small py-[8px] px-[5px] whitespace-nowrap overflow-hidden cursor-pointer"
            onClick={()=>{
              if(!isActive){
                callbackIds(message.thread_id)
              }
             
            }}
            aria-disabled={isActive}
            
          >
            {console.log(message)}
            {message?.summary?.title || "no summary"}
          </p>)
          
        })}
      </div>
    </div>
  );
};

export default ChatHistorySection;
